// extracted by css-extract-rspack-plugin
export default {"row":"hJwJl1","mastodonIcon":"ORkNz8","fbIcon":"RHhuDt","ytIcon":"BQ_KUL","githubIcon":"qxZXwC","androidIcon":"y3uzWc","appleIcon":"r2ORTe"};